import { type FunctionComponent, type PropsWithChildren, useContext } from 'react';
import { ConstructContext } from '../../contexts/construct/construct.context';
import { LinkButton } from '../buttons/link-button/link-button.component';

export type ContentContainerProps = {
	contentId: string;
};

export const ContentContainer: FunctionComponent<PropsWithChildren<ContentContainerProps>> = ({ contentId, children }) => {
	const { highlightContent, constructHost } = useContext(ConstructContext);
	return (
		<div className={`relative ${highlightContent ? 'shadow-5 bl b--theme-primary bw2' : ''}`}>
			{highlightContent && (
				<div className="absolute right-0 top-0 z-1">
					<LinkButton url={`${constructHost}/item/${contentId}`} openInNewTab={true} buttonStyle="INTERNAL">
						Edit in Construct
					</LinkButton>
				</div>
			)}
			{children}
		</div>
	);
};
